var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{attrs:{"clearable":"","placeholder":_vm.placeholder},on:{"change":_vm.selectChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},_vm._l((_vm.items),function(item){return _c('el-option',{key:item.code,attrs:{"label":item.value,"value":item.code}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }